// // config/config.jsx
// export const API = import.meta.env.VITE_BACKEND;
// export const SOCKET_IO_URL = import.meta.env.VITE_BACKEND_SOCKET_IO;
// export const API_IMAGES_BASE_URL = import.meta.env.VITE_BACKEND_IMAGES_BASE_URL;
// export const FRONTEND_DOMAIN = import.meta.env.VITE_FRONTEND_DOMAIN;

// export const iconStroke = 1.5;
// export const supportEmail = "aspos004@gmail.com";
// export const appVersion = "1.8.0";

// export const subscriptionAmount = 699;
// export const subscriptionPrice = "रु" + subscriptionAmount;

// export const stripeProductSubscriptionId = import.meta.env.VITE_STRIPE_PRODUCT_SUBSCRIPTION_KEY;

export const isElectronApp = () => {
  if (typeof window === "undefined") return false;
  return /electron/i.test(navigator.userAgent) || window.location.port === "5001";
};

export const getSyncMode = () => {
  if (typeof window === "undefined") return "online_only";
  return localStorage.getItem("sync_mode") || "online_only";
};

export const setSyncMode = (mode) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("sync_mode", mode);
  }
};

export const CLOUD_API_URL = "https://ehospitalitynepal.com/api/v1";
export const CLOUD_SOCKET_URL = "https://ehospitalitynepal.com";
export const CLOUD_IMAGES_URL = "https://ehospitalitynepal.com/public";

export const getApiBaseUrl = () => {
  if (!isElectronApp()) {
    return (import.meta.env.VITE_BACKEND && import.meta.env.VITE_BACKEND.includes("localhost") && typeof window !== "undefined" && !window.location.hostname.includes("localhost")
      ? `${window.location.origin}/api/v1`
      : (import.meta.env.VITE_BACKEND || CLOUD_API_URL));
  }

  // Running inside Electron desktop app:
  // online_only mode → connect directly to cloud server ONLY when internet is actually reachable
  const isBrowserOnline = typeof navigator !== "undefined" ? navigator.onLine !== false : true;
  if (getSyncMode() === 'online_only' && isBrowserOnline) {
    return CLOUD_API_URL;
  }
  // offline_sync mode OR offline fallback → use local SQLite backend
  const host = (typeof window !== "undefined" && window.location.hostname) ? window.location.hostname : "localhost";
  const port = (typeof window !== "undefined" && window.location.port) ? window.location.port : "5001";
  return `http://${host}:${port}/api/v1`;
};

export const getSocketUrl = () => {
  if (!isElectronApp()) {
    return (import.meta.env.VITE_BACKEND_SOCKET_IO && import.meta.env.VITE_BACKEND_SOCKET_IO.includes("localhost") && typeof window !== "undefined" && !window.location.hostname.includes("localhost")
      ? window.location.origin
      : (import.meta.env.VITE_BACKEND_SOCKET_IO || CLOUD_SOCKET_URL));
  }

  // online_only mode → connect directly to cloud socket
  if (getSyncMode() === 'online_only') {
    return CLOUD_SOCKET_URL;
  }
  const host = (typeof window !== "undefined" && window.location.hostname) ? window.location.hostname : "localhost";
  const port = (typeof window !== "undefined" && window.location.port) ? window.location.port : "5001";
  return `http://${host}:${port}`;
};

export const getApiImagesBaseUrl = () => {
  if (!isElectronApp()) {
    return (import.meta.env.VITE_BACKEND_IMAGES_BASE_URL && import.meta.env.VITE_BACKEND_IMAGES_BASE_URL.includes("localhost") && typeof window !== "undefined" && !window.location.hostname.includes("localhost")
      ? `${window.location.origin}/public`
      : (import.meta.env.VITE_BACKEND_IMAGES_BASE_URL || CLOUD_IMAGES_URL));
  }

  // online_only mode → images from cloud
  if (getSyncMode() === 'online_only') {
    return CLOUD_IMAGES_URL;
  }
  const host = (typeof window !== "undefined" && window.location.hostname) ? window.location.hostname : "localhost";
  const port = (typeof window !== "undefined" && window.location.port) ? window.location.port : "5001";
  return `http://${host}:${port}/public`;
};

export const API = getApiBaseUrl();
export const VITE_BACKEND_SOCKET_IO = getSocketUrl();
export const API_IMAGES_BASE_URL = getApiImagesBaseUrl();
export const FRONTEND_DOMAIN = isElectronApp() && getSyncMode() === "offline_sync"
  ? `http://${(typeof window !== "undefined" && window.location.hostname) ? window.location.hostname : "localhost"}:5001`
  : (typeof window !== "undefined" ? window.location.origin : "http://localhost:8080");

export const iconStroke = 1.5;

export const supportEmail = "aspos004@gmail.com";
export const appVersion = "1.8.0";

export const subscriptionAmount = 699;
export const subscriptionPrice = "रु" + subscriptionAmount;

export const stripeProductSubscriptionId = import.meta.env.VITE_STRIPE_PRODUCT_SUBSCRIPTION_KEY;